import { gql } from "@apollo/client";

export const SAVED_CLIP_STATUS = gql`
  query SavedClipStatus {
    savedClipStatus {
      success
      savedCount
      limit
      errors {
        field
        code
        message
      }
    }
  }
`;
